/**
 * Patch System for Jersey Zone Store
 * Manages patch product selection and cart integration
 */

(function () {
  console.log('[Patch System] Script Initializing...');
  // Store selected patch products
  const selectedPatches = new Map();
  // Store cart item keys for patches (to remove them later)
  const patchCartKeys = new Map();
  // Store patch cart line IDs to track which patches are in cart
  const patchCartLineIds = new Map();
  // Flag to prevent infinite loops when syncing patch properties
  let isSyncingPatchProperties = false;
  // Flag to prevent infinite loops when deselecting patches programmatically
  let isDeselectingPatches = false;
  // Flag to prevent sync during our own cart updates
  let isAddingPatches = false;

  // Get product data from global variable (set by Liquid template)
  const productCollections = window.PATCH_SYSTEM_DATA?.productCollections || [];
  const productTitle = window.PATCH_SYSTEM_DATA?.productTitle || '';
  const productFormId = window.PATCH_SYSTEM_DATA?.productFormId || '';
  const productData = window.PATCH_SYSTEM_DATA?.product || {};

  // Flags for patch loading
  let patchesLoaded = false;
  let isLoadingPatches = false;
  let patchSectionExpanded = false;

  // Club to league mapping based on simplified names
  const clubToLeagueMap = {
    // Premier League
    'arsenal': 'premier-league',
    'aston villa': 'premier-league',
    'bournemouth': 'premier-league',
    'brentford': 'premier-league',
    'brighton': 'premier-league',
    'burnley': 'premier-league',
    'chelsea': 'premier-league',
    'crystal palace': 'premier-league',
    'everton': 'premier-league',
    'fulham': 'premier-league',
    'leeds': 'premier-league',
    'liverpool': 'premier-league',
    'manchester': 'premier-league',
    'newcastle': 'premier-league',
    'nottingham': 'premier-league',
    'sunderland': 'premier-league',
    'tottenham': 'premier-league',
    'west ham': 'premier-league',
    'wolves': 'premier-league',

    // La Liga
    'real madrid': 'laliga',
    'barcelona': 'laliga',
    'atletico': 'laliga',
    'sevilla': 'laliga',
    'betis': 'laliga',
    'valencia': 'laliga',
    'villarreal': 'laliga',
    'sociedad': 'laliga',
    'bilbao': 'laliga',
    'getafe': 'laliga',
    'osasuna': 'laliga',
    'espanyol': 'laliga',
    'celta': 'laliga',
    'granada': 'laliga',
    'mallorca': 'laliga',
    'rayo': 'laliga',
    'alaves': 'laliga',
    'leganes': 'laliga',
    'levante': 'laliga',

    // Bundesliga
    'bayern': 'bundesliga',
    'dortmund': 'bundesliga',
    'leipzig': 'bundesliga',
    'leverkusen': 'bundesliga',
    'stuttgart': 'bundesliga',
    'frankfurt': 'bundesliga',
    'wolfsburg': 'bundesliga',
    'gladbach': 'bundesliga',
    'hoffenheim': 'bundesliga',
    'freiburg': 'bundesliga',
    'mainz': 'bundesliga',
    'augsburg': 'bundesliga',
    'bochum': 'bundesliga',
    'köln': 'bundesliga',
    'union berlin': 'bundesliga',
    'werder': 'bundesliga',
    'heidenheim': 'bundesliga',
    'darmstadt': 'bundesliga',

    // Serie A
    'juventus': 'serie-a',
    'inter milan': 'serie-a',
    'milan': 'serie-a',
    'roma': 'serie-a',
    'lazio': 'serie-a',
    'napoli': 'serie-a',
    'atalanta': 'serie-a',
    'fiorentina': 'serie-a',
    'torino': 'serie-a',
    'bologna': 'serie-a',
    'verona': 'serie-a',
    'udinese': 'serie-a',
    'genoa': 'serie-a',
    'lecce': 'serie-a',
    'empoli': 'serie-a',
    'monza': 'serie-a',
    'cagliari': 'serie-a',
    'sassuolo': 'serie-a',

    // Ligue 1
    'paris': 'ligue-1',
    'marseille': 'ligue-1',
    'lyon': 'ligue-1',
    'monaco': 'ligue-1',
    'lille': 'ligue-1',
    'nice': 'ligue-1',
    'rennes': 'ligue-1',
    'nantes': 'ligue-1',
    'strasbourg': 'ligue-1',
    'montpellier': 'ligue-1',
    'toulouse': 'ligue-1',
    'reims': 'ligue-1',
    'metz': 'ligue-1',
    'brest': 'ligue-1',
    'lens': 'ligue-1',
    'lorient': 'ligue-1',
    'auxerre': 'ligue-1',
    'clermont': 'ligue-1',

    // Liga Portugal
    'benfica': 'liga-portugal',
    'porto': 'liga-portugal',
    'sporting': 'liga-portugal',
    'braga': 'liga-portugal',
    'guimaraes': 'liga-portugal',
    'boavista': 'liga-portugal',
    'estoril': 'liga-portugal',
    'famalicao': 'liga-portugal',
    'rio ave': 'liga-portugal',
    'arouca': 'liga-portugal',
    'casa pia': 'liga-portugal',
    'vizela': 'liga-portugal',
    'gil vicente': 'liga-portugal',
    'moreirense': 'liga-portugal',
    'portimonense': 'liga-portugal',

    // Brasileirão
    'flamengo': 'brasileirao',
    'fluminense': 'brasileirao',
    'botafogo': 'brasileirao',
    'vasco': 'brasileirao',
    'corinthians': 'brasileirao',
    'palmeiras': 'brasileirao',
    'são paulo': 'brasileirao',
    'sao paulo': 'brasileirao',
    'santos': 'brasileirao',
    'grêmio': 'brasileirao',
    'gremio': 'brasileirao',
    'internacional': 'brasileirao',
    'cruzeiro': 'brasileirao',
    'atlético mineiro': 'brasileirao',
    'atletico mineiro': 'brasileirao',
    'athletico': 'brasileirao',
    'bahia': 'brasileirao',
    'fortaleza': 'brasileirao',
    'ceará': 'brasileirao',
    'ceara': 'brasileirao',
    'goiás': 'brasileirao',
    'goias': 'brasileirao',
    'cuiabá': 'brasileirao',
    'cuiaba': 'brasileirao',
    'red bull bragantino': 'brasileirao',
    'bragantino': 'brasileirao',
    'coritiba': 'brasileirao',
    'vitória': 'brasileirao',
    'vitoria': 'brasileirao',
    'américa mineiro': 'brasileirao',
    'america mineiro': 'brasileirao',

    // Liga MX
    'américa': 'liga-mx',
    'america': 'liga-mx',
    'atlas': 'liga-mx',
    'atletico de san luis': 'liga-mx',
    'atletico san luis': 'liga-mx',
    'cruz azul': 'liga-mx',
    'guadalajara': 'liga-mx',
    'chivas': 'liga-mx',
    'chivas de guadalajara': 'liga-mx',
    'león': 'liga-mx',
    'leon': 'liga-mx',
    'monterrey': 'liga-mx',
    'rayados': 'liga-mx',
    'necaxa': 'liga-mx',
    'pachuca': 'liga-mx',
    'puebla': 'liga-mx',
    'pumas': 'liga-mx',
    'querétaro': 'liga-mx',
    'queretaro': 'liga-mx',
    'santos laguna': 'liga-mx',
    'tigres': 'liga-mx',
    'tijuana': 'liga-mx',
    'toluca': 'liga-mx',
    'deportivo toluca': 'liga-mx'
  };

  // Champions League specific club patches (order matters - more specific first)
  const championsLeagueClubPatches = {
    'eintracht frankfurt': 'patch-champions-league',
    'atletico madrid': 'patch-champions-league',
    'borussia dortmund': 'patch-champions-league',
    'bayer leverkusen': 'patch-champions-league',
    'real madrid': 'patch-champions-league-15',
    'barcelona': 'patch-champions-league-5',
    'bayern': 'patch-champions-league-6',
    'liverpool': 'patch-champions-league-6',
    'milan': 'patch-champions-league-7',
    'chelsea': 'patch-world-champions',
    'paris': 'patch-uefa-champions-25-26',
    'tottenham': 'patch-champions-league',
    'atalanta': 'patch-champions-league',
    'monaco': 'patch-champions-league',
    'juventus': 'patch-champions-league',
    'sporting cp': 'patch-champions-league',
    'marseille': 'patch-champions-league',
    'villarreal': 'patch-champions-league',
    'manchester': 'patch-champions-league',
    'napoli': 'patch-champions-league',
    'benfica': 'patch-champions-league',
    'olympiacos': 'patch-champions-league'
  };

  // Libertadores patches
  const libertadoresPatches = {
    'flamengo': 'patch-libertadores-3',
    'palmeiras': 'patch-libertadores-3',
    'são paulo': 'patch-libertadores-3',
    'sao paulo': 'patch-libertadores-3',
    'internacional': 'patch-libertadores-2',
    'cruzeiro': 'patch-libertadores-2'
  };

  // Final Libertadores 2025
  const finalLibertadores2025Clubs = {
    'flamengo': 'patch-final-libertadores-2025',
    'palmeiras': 'patch-final-libertadores-2025'
  };

  // Participation Libertadores
  const participationLibertadoresClubs = ['internacional', 'corinthians', 'bahia', 'flamengo', 'botafogo', 'palmeiras', 'fortaleza', 'são paulo', 'sao paulo'];

  // Copa do Brasil
  const copaBrasilClubs = {
    'flamengo': 'patch-participation-copa-do-brasil',
    'palmeiras': 'patch-participation-copa-do-brasil',
    'são paulo': 'patch-participation-copa-do-brasil',
    'sao paulo': 'patch-participation-copa-do-brasil',
    'corinthians': 'patch-participation-copa-do-brasil',
    'santos': 'patch-participation-copa-do-brasil',
    'internacional': 'patch-participation-copa-do-brasil',
    'grêmio': 'patch-participation-copa-do-brasil',
    'gremio': 'patch-participation-copa-do-brasil',
    'atlético mineiro': 'patch-participation-copa-do-brasil',
    'atletico mineiro': 'patch-participation-copa-do-brasil',
    'athletico paranaense': 'patch-participation-copa-do-brasil',
    'athletico': 'patch-participation-copa-do-brasil',
    'fluminense': 'patch-participation-copa-do-brasil',
    'vasco da gama': 'patch-participation-copa-do-brasil',
    'vasco': 'patch-participation-copa-do-brasil',
    'cruzeiro': 'patch-participation-copa-do-brasil'
  };

  // Sudamericana
  const sudamericanaClubs = {
    'atlético mineiro': 'patch-participation-sudamericana',
    'atletico mineiro': 'patch-participation-sudamericana',
    'fluminense': 'patch-participation-sudamericana',
    'corinthians': 'patch-participation-sudamericana',
    'cruzeiro': 'patch-participation-sudamericana',
    'grêmio': 'patch-participation-sudamericana',
    'gremio': 'patch-participation-sudamericana',
    'vasco da gama': 'patch-participation-sudamericana',
    'vasco': 'patch-participation-sudamericana',
    'lanús': 'patch-participation-sudamericana',
    'lanus': 'patch-participation-sudamericana',
    'independiente': 'patch-participation-sudamericana',
    'godoy cruz': 'patch-participation-sudamericana',
    'huracán': 'patch-participation-sudamericana',
    'huracan': 'patch-participation-sudamericana',
    'independiente del valle': 'patch-participation-sudamericana',
    'bolívar': 'patch-participation-sudamericana',
    'bolivar': 'patch-participation-sudamericana',
    'once caldas': 'patch-participation-sudamericana',
    'alianza lima': 'patch-participation-sudamericana',
    'universidad de chile': 'patch-participation-sudamericana'
  };

  const titleKeywordPatches = [
    { keywords: ['world cup 2026', '2026 world cup', 'world cup'], handle: 'patch-world-cup-2026' }
  ];

  // National team patches mapping
  const nationalTeamPatches = {
    'portugal': 'patch-uefa-nations-league-winners-2025'
  };

  const customClubPatches = {
    'cruz azul': 'patches-cruz-azul-champions-24-25'
  };

  const worldCup2025ClubPatches = {
    'chelsea': 'patch-world-cup-2025-participation',
    'paris saint-germain': 'patch-world-cup-2025-participation',
    'psg': 'patch-world-cup-2025-participation',
    'real madrid': 'patch-world-cup-2025-participation',
    'bayern': 'patch-world-cup-2025-participation',
    'borussia dortmund': 'patch-world-cup-2025-participation',
    'manchester city': 'patch-world-cup-2025-participation',
    'juventus': 'patch-world-cup-2025-participation',
    'inter milan': 'patch-world-cup-2025-participation',
    'atlético de madrid': 'patch-world-cup-2025-participation',
    'atletico de madrid': 'patch-world-cup-2025-participation',
    'atlético madrid': 'patch-world-cup-2025-participation',
    'porto': 'patch-world-cup-2025-participation',
    'benfica': 'patch-world-cup-2025-participation',
    'red bull salzburg': 'patch-world-cup-2025-participation',
    'fluminense': 'patch-world-cup-2025-participation',
    'palmeiras': 'patch-world-cup-2025-participation',
    'flamengo': 'patch-world-cup-2025-participation',
    'botafogo': 'patch-world-cup-2025-participation',
    'river plate': 'patch-world-cup-2025-participation',
    'boca juniors': 'patch-world-cup-2025-participation',
    'inter miami': 'patch-world-cup-2025-participation',
    'pachuca': 'patch-world-cup-2025-participation',
    'monterrey': 'patch-world-cup-2025-participation',
    'seattle sounders': 'patch-world-cup-2025-participation',
    'los angeles fc': 'patch-world-cup-2025-participation',
    'la fc': 'patch-world-cup-2025-participation',
    'al hilal': 'patch-world-cup-2025-participation',
    'al ahly': 'patch-world-cup-2025-participation',
    'mamelodi sundowns': 'patch-world-cup-2025-participation',
    'urawa red diamonds': 'patch-world-cup-2025-participation',
    'auckland city': 'patch-world-cup-2025-participation'
  };

  // League to patch handle mapping
  const leaguePatchMap = {
    'premier-league': 'patch-premier-league',
    'laliga': 'patch-laliga',
    'bundesliga': 'patch-bundesliga',
    'serie-a': 'patch-serie-a',
    'ligue-1': 'patch-ligue-1',
    'liga-portugal': 'patch-liga-portugal',
    'brasileirao': 'patch-brasileirao',
    'liga-mx': 'patch-participation-liga-mx'
  };

  // Function to detect league and club from product title
  function detectLeagueAndClub(productTitle) {
    const titleLower = productTitle.toLowerCase();
    const detected = {
      league: null,
      club: null,
      championsLeaguePatch: null,
      libertadoresPatch: null,
      participationLibertadores: false,
      finalLibertadores2025: null,
      copaBrasil: null,
      sudamericana: null,
      titleKeywordPatch: null,
      specialClubPatch: null,
      worldCup2025ClubPatch: null,
      nationalTeamPatch: null
    };

    // Check for National Team patches FIRST (before World Cup)
    const sortedNationalTeams = Object.entries(nationalTeamPatches).sort((a, b) => b[0].length - a[0].length);
    for (const [country, patchHandle] of sortedNationalTeams) {
      if (titleLower.includes(country.toLowerCase())) {
        detected.nationalTeamPatch = patchHandle;
        break;
      }
    }

    // Check for World Cup 2026 FIRST
    const has2026 = titleLower.includes('2026');
    const hasWorldCup = titleLower.includes('world cup') || titleLower.includes('worldcup');

    if (has2026 && hasWorldCup) {
      detected.titleKeywordPatch = 'patch-world-cup-2026';
    } else if (hasWorldCup &&
      !titleLower.includes('2025') &&
      !titleLower.includes('2026') &&
      !titleLower.includes('2024')) {
      detected.titleKeywordPatch = 'patch-world-cup-2026';
    }

    // Check for Champions League specific patches
    if (titleLower.includes('chelsea')) {
      detected.championsLeaguePatch = 'patch-world-champions';
      detected.club = 'chelsea';
    } else {
      const sortedChampionsPatches = Object.entries(championsLeagueClubPatches).sort((a, b) => b[0].length - a[0].length);
      for (const [club, patchHandle] of sortedChampionsPatches) {
        if (club === 'chelsea') continue;

        if (titleLower.includes(club.toLowerCase())) {
          detected.championsLeaguePatch = patchHandle;
          detected.club = club;
          break;
        }
      }
    }

    // Check for Libertadores patches
    for (const [club, patchHandle] of Object.entries(libertadoresPatches)) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.libertadoresPatch = patchHandle;
        detected.club = club;
      }
    }

    // Check for Participation Libertadores
    if (participationLibertadoresClubs.some(club => titleLower.includes(club.toLowerCase()))) {
      detected.participationLibertadores = true;
    }

    // Check for Final Libertadores 2025
    for (const [club, patchHandle] of Object.entries(finalLibertadores2025Clubs)) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.finalLibertadores2025 = patchHandle;
        detected.club = club;
        break;
      }
    }

    // Check for Copa do Brasil
    const sortedCopaBrasilClubs = Object.entries(copaBrasilClubs).sort((a, b) => b[0].length - a[0].length);
    for (const [club, patchHandle] of sortedCopaBrasilClubs) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.copaBrasil = patchHandle;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    // Check for Sudamericana
    const sortedSudamericanaClubs = Object.entries(sudamericanaClubs).sort((a, b) => b[0].length - a[0].length);
    for (const [club, patchHandle] of sortedSudamericanaClubs) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.sudamericana = patchHandle;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    // Check for World Cup 2025 club patches
    const sortedWorldCup2025Clubs = Object.entries(worldCup2025ClubPatches).sort((a, b) => b[0].length - a[0].length);
    for (const [club, patchHandle] of sortedWorldCup2025Clubs) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.worldCup2025ClubPatch = patchHandle;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    // Check for custom club-specific patches
    const sortedCustomClubPatches = Object.entries(customClubPatches).sort((a, b) => b[0].length - a[0].length);
    for (const [club, patchHandle] of sortedCustomClubPatches) {
      if (titleLower.includes(club.toLowerCase())) {
        detected.specialClubPatch = patchHandle;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    // Check club to league mapping
    const sortedClubs = Object.entries(clubToLeagueMap).sort((a, b) => b[0].length - a[0].length);
    for (const [club, league] of sortedClubs) {
      if (club === 'internacional') {
        if (titleLower.includes('internacional') && !titleLower.includes('inter milan')) {
          detected.league = league;
          if (!detected.club) {
            detected.club = club;
          }
          break;
        }
      } else if (titleLower.includes(club.toLowerCase())) {
        detected.league = league;
        if (!detected.club) {
          detected.club = club;
        }
        break;
      }
    }

    return detected;
  }

  // Helper function to check if patch is a champion/trophies patch
  function isChampionOrTrophiesPatch(patch) {
    const handleLower = patch.handle.toLowerCase();
    const titleLower = patch.title.toLowerCase();

    if (handleLower.includes('patch-libertadores-2') ||
      handleLower.includes('patch-libertadores-3') ||
      handleLower.includes('patch-final-libertadores-')) {
      return true;
    }

    if (handleLower.includes('patch-champions-league') ||
      handleLower.includes('patch-world-champions') ||
      handleLower.includes('patch-uefa-champions')) {
      return true;
    }

    if (titleLower.includes('troféu') ||
      titleLower.includes('trophy') ||
      titleLower.includes('trophies') ||
      titleLower.includes('campeão') ||
      titleLower.includes('campeao') ||
      titleLower.includes('champion')) {
      return true;
    }

    return false;
  }

  // Helper function to check if patch is a participation patch
  function isParticipationPatch(patch) {
    if (isChampionOrTrophiesPatch(patch)) {
      return false;
    }
    return true;
  }

  // Function to validate and enforce sleeve patch selection rules
  function validateSleevePatchSelection(patch, patchKey, isNewPatch) {
    const isSleevePatch = patch.position === 'Sleeve';
    if (!isSleevePatch) return true;

    const isLibertadoresTrophiesPatch = isChampionOrTrophiesPatch(patch) &&
      (patch.handle.toLowerCase().includes('patch-libertadores-') ||
        patch.handle.toLowerCase().includes('patch-final-libertadores-'));

    const selectedSleevePatches = [];
    selectedPatches.forEach((selectedPatch, key) => {
      if (selectedPatch.position === 'Sleeve' && key !== patchKey) {
        selectedSleevePatches.push({ key, patch: selectedPatch });
      }
    });

    if (isLibertadoresTrophiesPatch) {
      removePatchesFromSelection(selectedSleevePatches);
      return true;
    }

    if (selectedSleevePatches.length > 0) {
      removePatchesFromSelection(selectedSleevePatches);
    }

    return true;
  }

  // Helper function to remove patches from selection
  function removePatchesFromSelection(patchesToRemove) {
    if (patchesToRemove.length === 0) return;

    isDeselectingPatches = true;
    patchesToRemove.forEach(({ key }) => {
      selectedPatches.delete(key);
      document.querySelectorAll('.patch-product-item').forEach(item => {
        const itemPatchKey = item.dataset.patchKey;
        if (itemPatchKey === key) {
          const cb = item.querySelector('.patch-checkbox');
          if (cb) {
            cb.checked = false;
            item.classList.remove('selected');
            cb.dispatchEvent(new Event('change'));
          }
        }
      });
    });
    isDeselectingPatches = false;
  }

  // Function to get patch position
  function getPatchPosition(product) {
    const titleLower = product.title.toLowerCase();

    if (titleLower.includes('world champions') || titleLower.includes('chelsea') && titleLower.includes('champions')) {
      return 'Chest';
    }

    // UEFA Nations League Winners 2025 (Portugal) goes on Chest
    if (product.handle && product.handle.toLowerCase().includes('patch-uefa-nations-league-winners-2025')) {
      return 'Chest';
    }

    if (product.handle && product.handle.toLowerCase().includes('patch-final-libertadores-2025')) {
      return 'Sleeve';
    }

    if (product.tags && product.tags.length > 0) {
      const positionTags = ['manga', 'torax', 'costas', 'peito', 'sleeve', 'chest', 'back'];
      for (const tag of product.tags) {
        const tagLower = tag.toLowerCase();
        if (positionTags.includes(tagLower)) {
          if (tagLower === 'manga') return 'Sleeve';
          if (tagLower === 'torax' || tagLower === 'peito') return 'Chest';
          if (tagLower === 'costas') return 'Back';
          return tag.charAt(0).toUpperCase() + tag.slice(1);
        }
      }
    }

    if (titleLower.includes('manga') || titleLower.includes('sleeve')) return 'Sleeve';
    if (titleLower.includes('torax') || titleLower.includes('peito') || titleLower.includes('chest')) return 'Chest';
    if (titleLower.includes('costas') || titleLower.includes('back')) return 'Back';

    return 'Sleeve';
  }

  // Function to load patch products
  async function loadPatchProducts() {
    console.log('[Patch System] loadPatchProducts called');
    const patchProductsSelector = document.getElementById('patch-products-selector');
    const patchProductsList = document.getElementById('patch-products-list');

    if (!patchProductsSelector || !patchProductsList) {
      console.log('[Patch System] Selector or List not found in DOM');
      return;
    }

    console.log('[Patch System] State - isLoadingPatches:', isLoadingPatches, 'patchesLoaded:', patchesLoaded);
    if (isLoadingPatches || patchesLoaded) {
      return;
    }

    isLoadingPatches = true;
    const patchProductsLoading = patchProductsSelector.querySelector('.patch-products-loading');
    if (patchProductsLoading) {
      patchProductsLoading.style.display = 'block';
    }
    patchProductsList.innerHTML = '';
    selectedPatches.clear();

    const patchSectionWrapper = document.querySelector('.patch-section-wrapper');
    const patchSectionHeader = document.querySelector('.patch-section-header');

    try {
      // Get product title - try multiple sources
      let currentProductTitle = productTitle;

      // Fallback 1: Try to get from PATCH_SYSTEM_DATA (may be updated)
      if (window.PATCH_SYSTEM_DATA && window.PATCH_SYSTEM_DATA.productTitle) {
        currentProductTitle = window.PATCH_SYSTEM_DATA.productTitle;
      }

      // Fallback 2: Try to get from DOM (h1 with product title)
      if (!currentProductTitle || currentProductTitle.trim() === '') {
        const productTitleElement = document.querySelector('h1.product-form__title, h1.product__title, h1[data-product-title]');
        if (productTitleElement && productTitleElement.textContent) {
          currentProductTitle = productTitleElement.textContent.trim();
        }
      }

      // Fallback 3: Try to get from meta tag
      if (!currentProductTitle || currentProductTitle.trim() === '') {
        const metaTitle = document.querySelector('meta[property="og:title"]');
        if (metaTitle && metaTitle.content) {
          currentProductTitle = metaTitle.content.trim();
        }
      }

      if (currentProductTitle && currentProductTitle.toLowerCase().includes('patch')) {
        if (patchSectionWrapper) patchSectionWrapper.style.display = 'none';
        if (patchSectionHeader) patchSectionHeader.style.display = 'none';
        patchProductsList.innerHTML = '';
        if (patchProductsLoading) patchProductsLoading.style.display = 'none';
        patchesLoaded = true;
        isLoadingPatches = false;
        return;
      }

      if (!currentProductTitle || currentProductTitle.trim() === '') {
        console.warn('Patch System: Could not find product title');
        if (patchSectionWrapper) patchSectionWrapper.style.display = 'none';
        if (patchSectionHeader) patchSectionHeader.style.display = 'none';
        patchProductsList.innerHTML = '';
        if (patchProductsLoading) patchProductsLoading.style.display = 'none';
        patchesLoaded = true;
        isLoadingPatches = false;
        return;
      }

      // FIRST: Check manual patch rules from section configuration
      // Combine local rules from product-form with global rules from patch-setup section
      const localRules = window.PATCH_SYSTEM_DATA?.manualPatchRules || [];
      const globalRules = window.GLOBAL_PATCH_RULES || [];
      const manualPatchRules = [...localRules, ...globalRules];

      console.log('[Patch System] Local Rules:', localRules);
      console.log('[Patch System] Global Rules:', globalRules);
      console.log('[Patch System] Combined Manual Rules:', manualPatchRules);
      console.log('[Patch System] Product Title:', currentProductTitle);

      let patchHandles = [];
      const manualPatches = [];

      if (manualPatchRules.length > 0) {
        const titleLower = currentProductTitle.toLowerCase();
        console.log('[Patch System] Manual Rules to check: ' + manualPatchRules.length);
        manualPatchRules.forEach(function (rule) {
          console.log('[Patch System] Checking rule:', rule);

          // Inclusion Keywords
          const keywords = Array.isArray(rule.keywords) ? rule.keywords : [];
          const exclusionKeywords = Array.isArray(rule.keywordsExclusion) ? rule.keywordsExclusion : [];

          // 1. Check if ANY exclusion keyword matches
          const isExcluded = exclusionKeywords.some(function (keyword) {
            if (typeof keyword !== 'string' || keyword.trim() === '') return false;
            const keywordLower = keyword.toLowerCase().trim();
            const match = titleLower.includes(keywordLower);
            if (match) console.log('[Patch System] Exclusion match found: ' + keywordLower);
            return match;
          });

          if (isExcluded) {
            console.log('[Patch System] Rule skipped due to EXCLUSION for: ' + rule.patchHandle);
            return;
          }

          // 2. Check if ANY inclusion keyword matches
          let isIncluded = false;

          if (keywords.length > 0) {
            isIncluded = keywords.some(function (keyword) {
              if (typeof keyword !== 'string' || keyword.trim() === '') return false;
              const keywordLower = keyword.toLowerCase().trim();
              const match = titleLower.includes(keywordLower);
              if (match) console.log('[Patch System] Inclusion match found: ' + keywordLower);
              return match;
            });
          }

          if (isIncluded && rule.patchHandle) {
            console.log('[Patch System] SUCCESS! Adding patch: ' + rule.patchHandle);
            manualPatches.push({
              handle: rule.patchHandle,
              position: rule.position || 'Sleeve'
            });
          }
        });
      } else {
        console.log('[Patch System] No manual rules found to process.');
      }

      // 1. Add Manual Patches
      if (manualPatches.length > 0) {
        manualPatches.forEach(p => patchHandles.push(p.handle));
      }

      // 2. Add Automatic Detected Patches (Running detection in parallel with manual rules)
      const detected = detectLeagueAndClub(currentProductTitle);

      // Debug: Log detection results for troubleshooting
      if (currentProductTitle && currentProductTitle.toLowerCase().includes('corinthians')) {
        console.log('Corinthians product detected:', currentProductTitle);
        console.log('Detection results:', detected);
      }

      if (detected.championsLeaguePatch) {
        patchHandles.push(detected.championsLeaguePatch);
      }

      if (detected.libertadoresPatch) {
        patchHandles.push(detected.libertadoresPatch);
      }

      if (detected.participationLibertadores && !detected.libertadoresPatch) {
        patchHandles.push('patch-participation-libertadores');
      }

      if (detected.finalLibertadores2025) {
        patchHandles.push(detected.finalLibertadores2025);
      }

      if (detected.copaBrasil) {
        patchHandles.push(detected.copaBrasil);
      }

      if (detected.sudamericana) {
        patchHandles.push(detected.sudamericana);
      }

      if (detected.worldCup2025ClubPatch) {
        patchHandles.push(detected.worldCup2025ClubPatch);
      }

      if (detected.titleKeywordPatch) {
        patchHandles.push(detected.titleKeywordPatch);
      }

      if (!detected.titleKeywordPatch && currentProductTitle) {
        const titleLowerCheck = currentProductTitle.toLowerCase();
        if (titleLowerCheck.includes('2026') &&
          (titleLowerCheck.includes('world cup') || titleLowerCheck.includes('worldcup'))) {
          patchHandles.push('patch-world-cup-2026');
        }
      }

      if (detected.nationalTeamPatch) {
        patchHandles.push(detected.nationalTeamPatch);
      }

      if (detected.specialClubPatch) {
        patchHandles.push(detected.specialClubPatch);
      }

      // Add league patch (Brasileirão for Corinthians)
      if (detected.league && leaguePatchMap[detected.league]) {
        if (detected.league === 'liga-mx' && detected.specialClubPatch) {
          // Skip
        } else {
          patchHandles.push(leaguePatchMap[detected.league]);
        }
      }

      // Debug: Log final patch handles
      if (currentProductTitle && currentProductTitle.toLowerCase().includes('corinthians')) {
        console.log('Final patch handles:', patchHandles);
      }

      if (patchHandles.length === 0) {
        const relevantCollections = productCollections.filter(c => {
          return ['laliga', 'brasileirao', 'premier-league', 'bundesliga', 'serie-a', 'ligue-1', 'champions-league', 'liga-portugal', 'liga-mx'].includes(c);
        });

        relevantCollections.forEach(collection => {
          if (leaguePatchMap[collection]) {
            patchHandles.push(leaguePatchMap[collection]);
          }
        });
      }


      patchHandles = [...new Set(patchHandles)];

      if (patchHandles.length === 0) {
        if (patchSectionWrapper) patchSectionWrapper.style.display = 'none';
        if (patchSectionHeader) patchSectionHeader.style.display = 'none';
        patchProductsList.innerHTML = '';
        if (patchProductsLoading) patchProductsLoading.style.display = 'none';
        patchesLoaded = true;
        isLoadingPatches = false;
        return;
      }

      const patchProducts = [];
      const patchPositions = new Map(); // Store positions for manual patches

      // Store positions for manual patches
      if (manualPatches.length > 0) {
        manualPatches.forEach(patch => {
          patchPositions.set(patch.handle, patch.position);
        });
      }

      for (const handle of patchHandles) {
        try {
          // Robust handle check
          const actualHandle = (typeof handle === 'object' && handle !== null) ? (handle.handle || handle.patchHandle) : handle;

          if (!actualHandle || typeof actualHandle !== 'string') {
            console.warn('[Patch System] Invalid patch handle:', handle);
            continue;
          }

          const response = await fetch(`/products/${actualHandle}.js`);
          console.log(`[Patch System] Fetching result for ${actualHandle}: Status ${response.status}`);

          if (response.ok) {
            try {
              const product = await response.json();
              console.log(`[Patch System] Product JSON loaded for ${actualHandle}. ID: ${product.id}`);

              if (product && product.variants && product.variants.length > 0) {
                patchProducts.push(product);
              } else {
                console.warn(`[Patch System] Product ${actualHandle} has no variants or is invalid`);
              }
            } catch (jsonError) {
              console.warn(`[Patch System] JSON Parse Error for ${actualHandle}:`, jsonError);
            }
          } else {
            console.warn(`[Patch System] Fetch failed for ${actualHandle} with status ${response.status}`);
          }
        } catch (error) {
          console.error(`[Patch System] Network Error for ${actualHandle}:`, error);
        }
      }

      if (patchProducts.length === 0) {
        // Only hide if we didn't try to load any patches. 
        // If we had handles but found no products, show error.
        if (patchHandles.length > 0) {
          console.warn('[Patch System] Handles found but no products loaded. Handles:', patchHandles);
          patchProductsList.innerHTML = `
            <div class="patch-error-state" style="padding: 15px; text-align: center; border: 1px dashed #ccc; border-radius: 4px; color: #666;">
              <p><strong>Configured patches could not be loaded.</strong></p>
              <p style="font-size: 13px; margin-top: 5px;">Double-check your patch product URLs (handles).</p>
            </div>
           `;
          if (patchSectionWrapper) patchSectionWrapper.style.display = 'block';
          if (patchSectionHeader) patchSectionHeader.style.display = 'block';
        } else {
          if (patchSectionWrapper) patchSectionWrapper.style.display = 'none';
          if (patchSectionHeader) patchSectionHeader.style.display = 'none';
          patchProductsList.innerHTML = '';
        }
      } else {
        const patchesByPosition = new Map();

        patchProducts.forEach((product, index) => {
          if (!product || !product.variants || !product.variants[0]) {
            return;
          }
          const variant = product.variants[0];
          // Use manual position if available, otherwise use automatic detection
          const patchPosition = patchPositions.get(product.handle) || getPatchPosition(product);

          if (!patchesByPosition.has(patchPosition)) {
            patchesByPosition.set(patchPosition, []);
          }

          patchesByPosition.get(patchPosition).push({
            product: product,
            variant: variant,
            index: index
          });
        });

        patchesByPosition.forEach((patches, position) => {
          const sortedPatches = [...patches].sort((a, b) => {
            const patchA = { handle: a.product.handle, title: a.product.title };
            const patchB = { handle: b.product.handle, title: b.product.title };

            const isAParticipation = isParticipationPatch(patchA);
            const isBParticipation = isParticipationPatch(patchB);

            if (isAParticipation && !isBParticipation) return -1;
            if (!isAParticipation && isBParticipation) return 1;

            return 0;
          });

          const positionSection = document.createElement('div');
          positionSection.className = 'patch-position-section';

          const positionTitle = document.createElement('div');
          positionTitle.className = 'patch-position-title';
          positionTitle.textContent = position.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
          positionSection.appendChild(positionTitle);

          const patchesContainer = document.createElement('div');
          patchesContainer.className = 'patch-position-patches';

          sortedPatches.forEach(({ product, variant, index }) => {
            // STANDARDIZED: All patches use the same price calculation
            const priceValue = variant.price ? (variant.price / 100) : 5.00;
            const price = priceValue.toFixed(2);

            // STANDARDIZED: All patches use the same image logic
            let imageUrl = '';
            if (product.images && product.images.length > 0) {
              imageUrl = product.images[0];
            } else if (product.featured_image) {
              imageUrl = product.featured_image;
            } else {
              imageUrl = 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';
            }

            // STANDARDIZED: All patches use the same ID format
            const uniqueId = `patch-${product.id}-${variant.id}-${index}`;

            // STANDARDIZED: All patches use the same HTML structure
            const patchItem = document.createElement('div');
            patchItem.className = 'patch-product-item';
            patchItem.dataset.productId = product.id;
            patchItem.dataset.variantId = variant.id;
            patchItem.dataset.productHandle = product.handle;
            patchItem.dataset.price = price;
            patchItem.dataset.patchKey = `${variant.id}-${index}`;

            // STANDARDIZED: All patches use the same title formatting (preserve original case, just trim)
            const patchTitle = product.title.trim();

            // STANDARDIZED: All patches use identical HTML structure
            patchItem.innerHTML = `
              <div class="block-swatch">
                <input type="checkbox" id="${uniqueId}" class="block-swatch__radio patch-checkbox" data-variant-id="${variant.id}" data-price="${price}" data-patch-handle="${product.handle}">
                <label for="${uniqueId}" class="block-swatch__item">
                  <div class="patch-product-content">
                    <img src="${imageUrl}" alt="${patchTitle}" class="patch-product-image" loading="lazy">
                    <div class="patch-product-info">
                      <div class="patch-product-title">${patchTitle}</div>
                      <div class="patch-product-price">$${price}</div>
                    </div>
                  </div>
                </label>
              </div>
            `;

            const label = patchItem.querySelector('.block-swatch__item');
            if (label) {
              label.addEventListener('click', function (e) {
                if (e.target.type === 'checkbox') {
                  return;
                }
                e.preventDefault();
                const cb = patchItem.querySelector('.patch-checkbox');
                if (cb) {
                  cb.checked = !cb.checked;
                  cb.dispatchEvent(new Event('change'));
                }
              });
            }

            const checkbox = patchItem.querySelector('.patch-checkbox');

            checkbox.addEventListener('change', async function () {
              if (isDeselectingPatches) {
                return;
              }

              const patchKey = `${variant.id}-${index}`;

              if (this.checked) {
                const patch = {
                  id: variant.id,
                  productId: product.id,
                  handle: product.handle,
                  title: product.title,
                  price: parseFloat(price),
                  position: position
                };

                const isValid = validateSleevePatchSelection(patch, patchKey, true);

                if (!isValid) {
                  this.checked = false;
                  patchItem.classList.remove('selected');
                  return;
                }

                selectedPatches.set(patchKey, patch);
                patchItem.classList.add('selected');

                // Don't add to cart immediately - only store selection
                // Patches will be added when product is added

              } else {
                const patch = selectedPatches.get(patchKey);
                selectedPatches.delete(patchKey);
                patchItem.classList.remove('selected');
              }
            });

            patchesContainer.appendChild(patchItem);
          });

          positionSection.appendChild(patchesContainer);
          patchProductsList.appendChild(positionSection);
        });
      }

    } catch (error) {
      console.error('Error loading patches:', error);
      patchProductsList.innerHTML = '<p>Error loading patches. Please try again.</p>';
      if (patchProductsLoading) {
        patchProductsLoading.style.display = 'none';
      }
      patchesLoaded = true;
      isLoadingPatches = false;
    } finally {
      if (patchProductsLoading) {
        patchProductsLoading.style.display = 'none';
      }
      isLoadingPatches = false;
      patchesLoaded = true;
      window.patchesLoaded = true;
      window.isLoadingPatches = false;
    }
  }

  function clearSelectedPatchItems() {
    selectedPatches.clear();
    patchCartKeys.clear();
    patchCartLineIds.clear();
    document.querySelectorAll('.patch-product-item').forEach(item => item.classList.remove('selected'));
    document.querySelectorAll('.patch-checkbox').forEach(checkbox => {
      checkbox.checked = false;
    });
  }

  // Flag to prevent infinite loops when updating shirt properties
  let isUpdatingShirtProperties = false;

  // Removed custom loading animations - using theme's default loading instead

  // Sync patch selections with cart - remove patches that were removed from cart
  // Also update "Selected patches" property for all shirts in cart
  async function syncPatchesWithCart() {
    // Don't sync if we're currently adding patches ourselves or updating properties
    if (isAddingPatches || isUpdatingShirtProperties) {
      return;
    }

    try {
      console.log('[Patch System] Starting cart sync...');

      // Get current cart
      const cartUrl = window.themeVariables?.routes?.cartUrl || '/cart';
      const cartResponse = await fetch(`${cartUrl}.js`);
      const cartData = await cartResponse.json();

      if (!cartData || !cartData.items) {
        console.log('[Patch System] No cart data found');
        return;
      }

      console.log('[Patch System] Cart items:', cartData.items.length);

      // Find all patches in cart by checking properties
      const patchesInCartByLineId = new Set();
      const patchesInCartByUniqueId = new Set();
      const shirtVariantsWithPatches = new Set();

      cartData.items.forEach(item => {
        if (item.properties) {
          const shirtVariantId = item.properties._shirt_variant_id;
          const patchUniqueId = item.properties._patch_unique_id;
          if (shirtVariantId && patchUniqueId) {
            // This is a patch, store its cart key and unique ID
            patchesInCartByLineId.add(item.key || item.id || item.variant_id);
            patchesInCartByUniqueId.add(patchUniqueId);
            shirtVariantsWithPatches.add(shirtVariantId);
          }
        }
      });

      console.log('[Patch System] Shirts with patches:', Array.from(shirtVariantsWithPatches));

      // Collect all shirt variants that need property updates
      const shirtsToUpdate = new Set();

      // Check all shirts in cart
      cartData.items.forEach(item => {
        if (!item.properties || !item.properties._patch_unique_id) {
          // This is a shirt (not a patch)
          const shirtVariantId = item.variant_id.toString();
          // Check if this shirt has any patches in cart
          const hasPatches = Array.from(shirtVariantsWithPatches).some(id => id === shirtVariantId);
          const currentProperty = item.properties && item.properties['Selected patches'];

          // Need to update if:
          // 1. Shirt has patches but property might be wrong
          // 2. Shirt has property but no patches (remove property)
          if (hasPatches || currentProperty) {
            shirtsToUpdate.add(shirtVariantId);
          }
        }
      });

      console.log('[Patch System] Shirts to update:', Array.from(shirtsToUpdate));

      // CRITICAL: Check if patches were actually removed FIRST
      // Only show loading if a patch was removed from cart
      let patchWasRemoved = false;
      const patchesToRemove = [];

      if (selectedPatches.size > 0) {
        selectedPatches.forEach((patch, patchKey) => {
          // Check by stored cart line ID
          const cartLineId = patchCartLineIds.get(patchKey);
          if (cartLineId && !patchesInCartByLineId.has(cartLineId)) {
            // This patch was removed from cart
            patchesToRemove.push(patchKey);
            patchWasRemoved = true;
          }
        });
      }

      // Also check if any shirt has "Selected patches" but no patches in cart (patch was removed)
      cartData.items.forEach(item => {
        if (!item.properties || !item.properties._patch_unique_id) {
          // This is a shirt (not a patch)
          const shirtVariantId = item.variant_id.toString();
          const hasPatches = Array.from(shirtVariantsWithPatches).some(id => id === shirtVariantId);
          const hasProperty = item.properties && item.properties['Selected patches'];

          // If shirt has property but no patches, a patch was removed
          if (hasProperty && !hasPatches) {
            patchWasRemoved = true;
          }
        }
      });

      console.log('[Patch System] Patch was removed:', patchWasRemoved);

      // Remove patches from selectedPatches that are no longer in cart FIRST
      if (patchesToRemove.length > 0) {
        isDeselectingPatches = true;
        patchesToRemove.forEach(patchKey => {
          selectedPatches.delete(patchKey);
          patchCartLineIds.delete(patchKey);
          patchCartKeys.delete(patchKey);

          // Uncheck checkbox and remove selected class
          document.querySelectorAll('.patch-product-item').forEach(item => {
            const itemPatchKey = item.dataset.patchKey;
            if (itemPatchKey === patchKey) {
              item.classList.remove('selected');
              const cb = item.querySelector('.patch-checkbox');
              if (cb) {
                cb.checked = false;
              }
            }
          });
        });
        isDeselectingPatches = false;
      }

      // Only show loading and update if a patch was actually removed
      if (patchWasRemoved && shirtsToUpdate.size > 0) {
        isUpdatingShirtProperties = true;

        // Use theme's default loading - no custom animations
        console.log('[Patch System] Patch removed - updating shirts');

        // Fetch fresh cart data for each update
        for (const shirtVariantId of shirtsToUpdate) {
          try {
            const freshCartResponse = await fetch(`${cartUrl}.js`);
            if (freshCartResponse.ok) {
              const freshCartData = await freshCartResponse.json();
              console.log('[Patch System] Updating shirt variant:', shirtVariantId);
              await updateShirtPatchesProperty(freshCartData, shirtVariantId);
            }
            // Reduced delay for faster updates
            await new Promise(resolve => setTimeout(resolve, 100));
          } catch (error) {
            console.error('[Patch System] Error updating shirt:', error);
          }
        }

        isUpdatingShirtProperties = false;
        console.log('[Patch System] Finished updating shirts after patch removal');

        // Force mini cart to refresh after all updates are complete
        // Reduced delay for faster refresh
        setTimeout(async () => {
          await forceMiniCartRefresh();
        }, 200);
      } else if (shirtsToUpdate.size > 0 && !patchWasRemoved) {
        // Update without loading animation (silent update when no patch was removed)
        // This happens on initial load or other updates
        isUpdatingShirtProperties = true;

        for (const shirtVariantId of shirtsToUpdate) {
          try {
            const freshCartResponse = await fetch(`${cartUrl}.js`);
            if (freshCartResponse.ok) {
              const freshCartData = await freshCartResponse.json();
              // Silent update - no loading animation
              await updateShirtPatchesProperty(freshCartData, shirtVariantId);
            }
            await new Promise(resolve => setTimeout(resolve, 100));
          } catch (error) {
            console.error('[Patch System] Error updating shirt:', error);
          }
        }

        isUpdatingShirtProperties = false;
        console.log('[Patch System] Silent update completed (no patch removed, no animation)');
      } else {
        console.log('[Patch System] No shirts need updates');
      }

      // Also check if current product's variant has changed - clear patches if so
      const currentVariantId = getCurrentVariantId();
      if (currentVariantId) {
        selectedPatches.forEach((patch, patchKey) => {
          // Check if this patch belongs to a different shirt variant
          // This is a safety check - patches should already be cleared when adding to cart
          const cartLineId = patchCartLineIds.get(patchKey);
          if (cartLineId) {
            const cartItem = cartData.items.find(item => (item.key || item.id) === cartLineId);
            if (cartItem && cartItem.properties && cartItem.properties._shirt_variant_id) {
              const patchShirtVariantId = parseInt(cartItem.properties._shirt_variant_id, 10);
              if (patchShirtVariantId !== currentVariantId) {
                // This patch belongs to a different shirt, don't auto-remove it
                // Just skip it
              }
            }
          }
        });
      }

    } catch (error) {
      console.warn('Error syncing patches with cart:', error);
    }
  }

  // Force mini cart drawer to refresh with latest cart data
  async function forceMiniCartRefresh() {
    try {
      const cartUrl = window.themeVariables?.routes?.cartUrl || '/cart';

      // Fetch latest cart data
      const cartResponse = await fetch(`${cartUrl}.js`);
      if (!cartResponse.ok) return;

      const cartData = await cartResponse.json();

      // Fetch mini cart sections
      let sectionsHtml = null;
      try {
        const sectionsResponse = await fetch(`${cartUrl}?sections=mini-cart&_=${Date.now()}`);
        if (sectionsResponse.ok) {
          const sectionsData = await sectionsResponse.json();
          if (sectionsData.sections && sectionsData.sections['mini-cart']) {
            sectionsHtml = sectionsData.sections['mini-cart'];
            cartData.sections = sectionsData.sections;
          }
        }
      } catch (err) {
        console.warn('[Patch System] Could not load mini cart sections for refresh:', err);
      }

      // Update mini cart drawer if open
      const miniCartDrawer = document.getElementById('mini-cart');
      if (miniCartDrawer && sectionsHtml) {
        const drawerContent = miniCartDrawer.querySelector('.drawer__content, form#mini-cart-form');
        if (drawerContent) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sectionsHtml;
          const newContent = tempDiv.querySelector('.drawer__content, form#mini-cart-form');
          if (newContent) {
            drawerContent.innerHTML = newContent.innerHTML;
            console.log('[Patch System] Mini cart forcefully refreshed');
          }
        }
      }

      // Wait a bit before dispatching events
      await new Promise(resolve => setTimeout(resolve, 50));

      // Dispatch refresh events with flag to prevent re-sync
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cartData,
          openMiniCart: false,
          _patchSystemUpdate: true // Flag to prevent re-sync
        }
      }));

    } catch (error) {
      console.warn('[Patch System] Error forcing mini cart refresh:', error);
    }
  }

  // Update "Selected patches" property for a shirt in cart
  // Uses remove + re-add approach as it's the most reliable way to update properties in Shopify
  async function updateShirtPatchesProperty(cartData, shirtVariantId) {
    try {
      // Find the shirt item in cart (item that is NOT a patch)
      const shirtItem = cartData.items.find(item => {
        // Must match variant ID and NOT have patch properties
        return item.variant_id === parseInt(shirtVariantId, 10) &&
          (!item.properties || !item.properties._patch_unique_id);
      });

      if (!shirtItem) {
        console.warn('Shirt not found in cart for variant:', shirtVariantId);
        return;
      }

      // Find all patches in cart that belong to this shirt
      const patchesForShirt = cartData.items.filter(item =>
        item.properties &&
        item.properties._shirt_variant_id === shirtVariantId.toString() &&
        item.properties._patch_unique_id
      );

      // Get patch titles
      const patchTitles = patchesForShirt.map(patch => {
        return patch.product_title || patch.title || patch.name || 'Patch';
      }).filter(title => title && title !== 'Patch'); // Filter out generic "Patch" if we have better data

      // Get current "Selected patches" property value
      const currentSelectedPatches = (shirtItem.properties && shirtItem.properties['Selected patches']) || '';
      const newSelectedPatches = patchTitles.length > 0 ? patchTitles.join(', ') : '';

      // Check if property actually needs updating
      if (currentSelectedPatches === newSelectedPatches) {
        // No change needed, skip update
        return;
      }

      // Get current properties from shirt, excluding "Selected patches"
      const currentProperties = { ...(shirtItem.properties || {}) };
      delete currentProperties['Selected patches']; // Remove old value first

      // Add updated "Selected patches" if there are any patches
      const updatedProperties = { ...currentProperties };
      if (patchTitles.length > 0) {
        updatedProperties['Selected patches'] = newSelectedPatches;
      }

      // Get the line number for the shirt (1-based index)
      const lineNumber = cartData.items.findIndex(item => {
        const itemId = item.key || item.id;
        const shirtId = shirtItem.key || shirtItem.id;
        return itemId === shirtId;
      }) + 1;

      if (lineNumber <= 0) {
        console.warn('Could not find shirt line number in cart');
        return;
      }

      // Get selling plan if exists
      const sellingPlanId = shirtItem.selling_plan_allocation?.selling_plan?.id;

      // Method 1: Try using cart/update.js with line-based update
      // First, remove the item
      const removeUrl = `/cart/change.js?line=${lineNumber}&quantity=0`;
      const removeResponse = await fetch(removeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!removeResponse.ok) {
        console.warn('Could not remove shirt from cart for property update');
        return;
      }

      // Reduced wait time for faster updates
      await new Promise(resolve => setTimeout(resolve, 50));

      // Now re-add the shirt with updated properties
      const addItem = {
        id: parseInt(shirtItem.variant_id, 10),
        quantity: shirtItem.quantity
      };

      // Add selling plan if exists
      if (sellingPlanId) {
        addItem.selling_plan = sellingPlanId;
      }

      // Add properties only if there are any non-empty values
      const propertiesToAdd = {};
      Object.entries(updatedProperties).forEach(([key, value]) => {
        // Only add properties that don't start with underscore (internal) and have values
        if (!key.startsWith('_') && value && value.toString().trim() !== '') {
          propertiesToAdd[key] = value.toString();
        }
      });

      if (Object.keys(propertiesToAdd).length > 0) {
        addItem.properties = propertiesToAdd;
      }

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [addItem]
        })
      });

      if (!addResponse.ok) {
        console.warn('Could not re-add shirt to cart with updated properties');
        // Try to restore original item
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(shirtItem.variant_id, 10),
              quantity: shirtItem.quantity,
              ...(sellingPlanId && { selling_plan: sellingPlanId }),
              ...(shirtItem.properties && { properties: shirtItem.properties })
            }]
          })
        });
        return;
      }

      // Refresh cart after update and fetch sections for mini cart
      const cartUrl = window.themeVariables?.routes?.cartUrl || '/cart';

      // Reduced wait time for faster updates
      await new Promise(resolve => setTimeout(resolve, 150));

      // Fetch fresh cart data
      const updatedCartResponse = await fetch(`${cartUrl}.js`);

      if (updatedCartResponse.ok) {
        const updatedCart = await updatedCartResponse.json();

        // Fetch cart sections to update mini cart/drawer - this is critical for live updates
        let sectionsHtml = null;
        try {
          const sectionsResponse = await fetch(`${cartUrl}?sections=mini-cart&_=${Date.now()}`);
          if (sectionsResponse.ok) {
            const sectionsData = await sectionsResponse.json();
            if (sectionsData.sections && sectionsData.sections['mini-cart']) {
              sectionsHtml = sectionsData.sections['mini-cart'];
              updatedCart.sections = sectionsData.sections;
              console.log('[Patch System] Mini cart sections loaded');
            }
          }
        } catch (err) {
          console.warn('[Patch System] Could not load mini cart sections:', err);
        }

        // Force mini cart drawer to update if it's open
        try {
          const miniCartDrawer = document.getElementById('mini-cart');
          if (miniCartDrawer) {
            // If sections HTML is available, update directly
            if (sectionsHtml) {
              // Find the drawer content area
              const drawerContent = miniCartDrawer.querySelector('.drawer__content, form#mini-cart-form');
              if (drawerContent) {
                // Create temporary container to parse new HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = sectionsHtml;

                // Find the new content in the sections HTML
                const newContent = tempDiv.querySelector('.drawer__content, form#mini-cart-form');
                if (newContent) {
                  // Replace the content
                  drawerContent.innerHTML = newContent.innerHTML;
                  console.log('[Patch System] Mini cart content updated directly');

                  // Loading will be removed before dispatching events
                }
              }
            }

            // Try to call refresh method if it exists
            if (typeof miniCartDrawer.refresh === 'function') {
              miniCartDrawer.refresh(updatedCart);
              console.log('[Patch System] Mini cart refresh method called');
            }

            // Trigger any observers or custom events
            miniCartDrawer.dispatchEvent(new CustomEvent('refresh', {
              bubbles: true,
              detail: { cart: updatedCart }
            }));
          }
        } catch (err) {
          console.warn('[Patch System] Could not manually refresh mini cart:', err);
        }

        // DON'T remove loading here - it will be removed by syncPatchesWithCart after update completes
        // The loading should stay visible during the update

        // Dispatch cart updated event to refresh UI (including mini cart)
        // Mark event to prevent re-sync (would cause infinite loop)
        const updatedEvent = new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: updatedCart,
            _patchSystemUpdate: true // Flag to prevent re-sync
          }
        });
        document.documentElement.dispatchEvent(updatedEvent);

        // Dispatch cart refresh event to force mini cart/drawer update
        // Mark event to prevent re-sync
        const refreshEvent = new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: updatedCart,
            openMiniCart: false, // Don't open, just refresh
            _patchSystemUpdate: true // Flag to prevent re-sync
          }
        });
        document.documentElement.dispatchEvent(refreshEvent);

        console.log('[Patch System] Cart refresh events dispatched (marked to prevent re-sync)');
      }

    } catch (error) {
      console.error('Error updating shirt patches property:', error);
    }
  }

  function extractPropertiesFromForm(formData) {
    const properties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[')) {
        const propertyName = key.slice(11, -1);
        if (value && value.trim() !== '') {
          properties[propertyName] = value;
        }
      }
    }
    return properties;
  }

  function getCurrentVariantId() {
    const productForm = document.getElementById(productFormId);
    if (!productForm) return null;
    const variantInput = productForm.querySelector('input[name="id"]');
    return variantInput ? parseInt(variantInput.value, 10) : null;
  }

  // CRITICAL FIX: Add patches FIRST, then main product
  // This ensures bot processes patches before the shirt, so it knows patches are included
  async function submitFormWithPatches(productForm) {
    const addButton = productForm.querySelector('[data-product-add-to-cart-button]');
    const secondaryButton = productForm.querySelector('[data-shopify="payment-button"] button');

    const setLoadingState = (isLoading) => {
      if (addButton) {
        if (isLoading) {
          addButton.setAttribute('aria-busy', 'true');
          addButton.classList.add('is-loading');
          addButton.disabled = true;
        } else {
          addButton.removeAttribute('aria-busy');
          addButton.classList.remove('is-loading');
          addButton.disabled = false;
        }
      }
      if (secondaryButton) {
        secondaryButton.disabled = isLoading;
      }
    };

    try {
      setLoadingState(true);

      const uniqueItemId = Date.now().toString() + '-' + Math.random().toString(36).substr(2, 9);

      const formData = new FormData(productForm);
      const quantity = parseInt(formData.get('quantity') || '1', 10);
      const variantId = formData.get('id');

      if (!variantId) {
        throw new Error('Please select a variant before adding to cart.');
      }

      const mainItem = {
        id: parseInt(variantId, 10),
        quantity: quantity
      };

      const sellingPlanId = formData.get('selling_plan');
      if (sellingPlanId) {
        mainItem.selling_plan = sellingPlanId;
      }

      const mainProperties = extractPropertiesFromForm(formData);
      if (Object.keys(mainProperties).length) {
        mainItem.properties = mainProperties;
      }

      // STEP 1: Add patches FIRST (one by one to ensure order)
      // This way the bot sees patches before the shirt and knows to process them together
      const patchTitles = [];
      // Generate unique ID for this shirt's patches (combines variant ID with timestamp)
      const shirtUniqueId = `shirt-${variantId}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

      if (selectedPatches.size > 0) {
        const validatedPatches = [];

        selectedPatches.forEach((patch, patchKey) => {
          const isValid = validateSleevePatchSelection(patch, patchKey, false);
          if (isValid) {
            validatedPatches.push({ patch, patchKey });
            patchTitles.push(patch.title);
          } else {
            selectedPatches.delete(patchKey);
            document.querySelectorAll('.patch-product-item').forEach(item => {
              const itemPatchKey = item.dataset.patchKey;
              if (itemPatchKey === patchKey) {
                const cb = item.querySelector('.patch-checkbox');
                if (cb) {
                  cb.checked = false;
                  item.classList.remove('selected');
                }
              }
            });
          }
        });

        // Add each patch sequentially FIRST
        // CRITICAL: Add unique properties to each patch so they don't get grouped together
        // Each patch gets a unique ID linked to the shirt variant to keep them separate
        isAddingPatches = true;
        for (let i = 0; i < validatedPatches.length; i++) {
          const { patch, patchKey } = validatedPatches[i];
          try {
            // Generate unique patch ID for this specific patch instance
            const uniquePatchId = `${shirtUniqueId}-patch-${i}-${patch.id}`;

            const patchResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [{
                  id: parseInt(patch.id, 10),
                  quantity: quantity,
                  properties: {
                    '_shirt_variant_id': variantId.toString(),
                    '_patch_unique_id': uniquePatchId,
                    '_patch_position': patch.position || 'Sleeve'
                  }
                }]
              })
            });

            if (patchResponse.ok) {
              // After adding patch, fetch updated cart to get line IDs
              try {
                const cartUrl = window.themeVariables?.routes?.cartUrl || '/cart';
                const updatedCartResponse = await fetch(`${cartUrl}.js`);
                if (updatedCartResponse.ok) {
                  const updatedCart = await updatedCartResponse.json();
                  // Find the patch we just added by matching properties
                  const addedPatch = updatedCart.items.find(item =>
                    item.properties &&
                    item.properties._patch_unique_id === uniquePatchId &&
                    item.variant_id === parseInt(patch.id, 10)
                  );
                  if (addedPatch) {
                    // Store cart line ID (key) for this patch to track it later
                    patchCartLineIds.set(patchKey, addedPatch.key || addedPatch.id || addedPatch.variant_id);
                  }
                }
              } catch (err) {
                console.warn('Could not fetch cart after adding patch:', err);
              }
            }
          } catch (patchError) {
            console.warn('Error adding patch:', patchError);
          }
        }
        isAddingPatches = false;
      }

      // STEP 2: Add main product AFTER patches
      // BOT-OPTIMIZED: Keep main product properties minimal and standard
      // Only add user-visible patch information
      if (patchTitles.length > 0) {
        mainItem.properties = mainItem.properties || {};
        mainItem.properties['Selected patches'] = patchTitles.join(', ');
        // Note: Removed technical linking properties to keep product "clean" for bot processing
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: [mainItem] })
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.description || responseData.message || 'Error adding product to cart');
      }

      // Refresh cart
      const cartUrl = window.themeVariables?.routes?.cartUrl || '/cart';
      const cartResponse = await fetch(`${cartUrl}.js`);
      const cartData = await cartResponse.json();

      try {
        const sectionsResponse = await fetch(`${cartUrl}?sections=mini-cart`);
        if (sectionsResponse.ok) {
          const sectionsData = await sectionsResponse.json();
          cartData.sections = sectionsData.sections;
        }
      } catch (err) {
        console.warn('Could not load sections:', err);
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartData }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cartData,
          openMiniCart: window.themeVariables?.settings?.cartType === 'drawer'
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('variant:added', {
        bubbles: true,
        detail: {
          product: productData,
          variantId: parseInt(variantId, 10),
          quantity: quantity
        }
      }));

      // Clear patch selections after successful addition
      patchCartKeys.clear();
      patchCartLineIds.clear();
      selectedPatches.clear();

      document.querySelectorAll('.patch-product-item').forEach(item => item.classList.remove('selected'));
      document.querySelectorAll('.patch-checkbox').forEach(checkbox => {
        checkbox.checked = false;
      });

    } catch (error) {
      console.error('Error adding product:', error);
      alert(error.message || 'Error adding product to cart. Please try again.');
    } finally {
      setLoadingState(false);
    }
  }

  // Make functions available globally
  window.PATCH_SYSTEM = {
    loadPatchProducts: loadPatchProducts,
    submitFormWithPatches: submitFormWithPatches,
    clearSelectedPatchItems: clearSelectedPatchItems,
    getCurrentVariantId: getCurrentVariantId,
    selectedPatches: selectedPatches,
    get patchesLoaded() { return patchesLoaded; },
    get isLoadingPatches() { return isLoadingPatches; }
  };

  // Initialize patch toggle
  function initPatchToggle() {
    const patchSectionToggle = document.querySelector('.patch-section-toggle');
    if (!patchSectionToggle) {
      return;
    }

    const patchProductsSelector = document.getElementById('patch-products-selector');
    if (!patchProductsSelector) {
      return;
    }

    if (patchSectionToggle.dataset.listenerAttached === 'true') {
      return;
    }

    patchSectionToggle.dataset.listenerAttached = 'true';

    patchSectionToggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      patchSectionExpanded = !patchSectionExpanded;
      const selector = document.getElementById('patch-products-selector');
      const patchList = document.getElementById('patch-products-list');
      const arrowDown = document.querySelector('.patch-arrow-down');
      const arrowUp = document.querySelector('.patch-arrow-up');
      const wrapper = document.querySelector('.patch-section-wrapper');

      if (patchSectionExpanded) {
        if (selector) {
          selector.style.display = 'block';
          selector.style.maxHeight = 'none';
          selector.style.overflow = 'visible';
        }
        if (patchList) {
          patchList.style.display = 'block';
          patchList.style.maxHeight = 'none';
          patchList.style.overflow = 'visible';
        }
        if (arrowDown) arrowDown.style.display = 'none';
        if (arrowUp) arrowUp.style.display = 'block';
        if (wrapper) {
          wrapper.classList.add('expanded');
          wrapper.style.maxHeight = 'none';
        }
        if (window.PATCH_SYSTEM.loadPatchProducts && !window.PATCH_SYSTEM.patchesLoaded && !window.PATCH_SYSTEM.isLoadingPatches) {
          setTimeout(function () {
            window.PATCH_SYSTEM.loadPatchProducts();
          }, 100);
        }
      } else {
        // Force close immediately - remove display first, then hide
        if (selector) {
          selector.style.maxHeight = '0';
          selector.style.overflow = 'hidden';
          selector.style.paddingTop = '0';
          selector.style.paddingBottom = '0';
          selector.style.display = 'none';
        }
        if (patchList) {
          patchList.style.maxHeight = '0';
          patchList.style.overflow = 'hidden';
          patchList.style.display = 'none';
        }
        if (arrowDown) arrowDown.style.display = 'block';
        if (arrowUp) arrowUp.style.display = 'none';
        if (wrapper) {
          wrapper.classList.remove('expanded');
          wrapper.style.maxHeight = 'auto';
        }
      }
    });
  }

  // Auto-run if ready
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(initPatchToggle, 100);
    setTimeout(loadPatchProducts, 500); // Attempt to load automatically
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initPatchToggle, 100);
      setTimeout(loadPatchProducts, 500);
    });
  }

  // Also listen for Shopify section reloads (for editor)
  document.addEventListener('shopify:section:load', () => {
    console.log('[Patch System] Section reloaded');
    patchesLoaded = false;
    isLoadingPatches = false;
    window.patchesLoaded = false;
    setTimeout(loadPatchProducts, 500);
  });

})();

